export const HOME_SCROLL_POSITION_STORAGE_KEY = 'homeScrollY';

const HOME_SCROLLPORT_SELECTOR = '[data-home-scrollport]';

export const saveHomeScrollPosition = (): void => {
  const scrollport = document.querySelector<HTMLElement>(
    HOME_SCROLLPORT_SELECTOR
  );

  if (!scrollport) {
    return;
  }

  sessionStorage.setItem(
    HOME_SCROLL_POSITION_STORAGE_KEY,
    scrollport.scrollTop.toString()
  );
};
